module.exports = __webpack_public_path__ + "static/img/04.129b494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/04.jpg
// module id = sq2y
// module chunks = 0